var addSeconds = require('date-fns/addSeconds');
var jwtDecode = require('jwt-decode');
var toFormEncoding = require('form-urlencoded');
var utilihiveHttp = require('utilihive-http');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var addSeconds__default = /*#__PURE__*/_interopDefaultLegacy(addSeconds);
var jwtDecode__default = /*#__PURE__*/_interopDefaultLegacy(jwtDecode);
var toFormEncoding__default = /*#__PURE__*/_interopDefaultLegacy(toFormEncoding);

const fetchToken = async (body, url) => {
  const {
    access_token,
    refresh_token,
    expires_in
  } = await utilihiveHttp.post(url, {
    contentType: 'application/x-www-form-urlencoded',
    body: toFormEncoding__default["default"](body),
    stringifyBody: false
  });
  return {
    token: access_token,
    refreshToken: refresh_token,
    expires: addSeconds__default["default"](new Date(), expires_in).toString()
  };
};
const login = ({
  username,
  password,
  loginUrl
}) => fetchToken({
  grant_type: 'password',
  scope: 'metercloud-identity',
  username,
  password
}, loginUrl);
const refreshToken = ({
  refreshToken,
  refreshUrl
}) => fetchToken({
  grant_type: 'refresh_token',
  scope: 'metercloud-identity',
  refresh_token: refreshToken
}, refreshUrl);
const fetchLoggedInUserDetails = async ({
  token,
  endpointUrl
}) => {
  const {
    userId
  } = jwtDecode__default["default"](token);
  return utilihiveHttp.get(`${endpointUrl}/${userId}`, {
    token
  });
};
const fetchLoggedInUserOrganizationDetails = async ({
  token,
  endpointUrl
}) => utilihiveHttp.get(`${endpointUrl}/${jwtDecode__default["default"](token).organizationId}`, {
  token
});
const isTokenExpired = ({
  token
}) => {
  try {
    const {
      exp
    } = jwtDecode__default["default"](token);
    return !exp || exp < Date.now() / 1000;
  } catch (error) {
    return true;
  }
};
const decodeToken = token => jwtDecode__default["default"](token);

exports.decodeToken = decodeToken;
exports.fetchLoggedInUserDetails = fetchLoggedInUserDetails;
exports.fetchLoggedInUserOrganizationDetails = fetchLoggedInUserOrganizationDetails;
exports.isTokenExpired = isTokenExpired;
exports.login = login;
exports.refreshToken = refreshToken;
